import React from 'react';
import '../styles/index.css'

export default function About() {

  return (
    <section id='about'>
        <div className='col-12' style={{marginBottom:'10px'}}>
            <h3 style={{textAlign:'center', fontSizeAdjust:'inherit'}}>About Me</h3>
        </div>
        <div className='col-12'> 
          <img id='chrisPic' src='./images/Chris_Likedin_5star.png' alt='chris' 
          style={{
            height:'200px', width:'auto', borderRadius:'50%', display:'block', margin:'auto'
          }}/>
          <p className='col-8 mt-3' style={{
            fontSize: '16px', 
            margin: 'auto'
            }}>
              Welcome to my portfolio!  
              <br/>
              <br/>
My path here started with anthropology, not computer science. I spent college studying how people think, communicate, and make decisions, which honestly turned out to be great training for building software. Understanding a user's actual behavior, not just what they say they want, is half the battle in tech, and it's something I think about constantly.     
         <br/>
              <br/>
After graduating, I got curious about how things get built and jumped into a full stack coding bootcamp. From there, I worked as a Software Engineer at an early stage AI startup, where I built and debugged customer facing features, worked closely with the founders, and got comfortable moving across the entire stack in a fast moving environment. I've also spent time as a technical instructor, which taught me how to take something complicated and explain it in a way that actually clicks for someone.
              <br/>
                            <br/>

Right now, I'm in a customer facing role at Verizon, where the job is part sales, part troubleshooting, and part figuring out creative solutions inside a constantly shifting set of rules. Every day involves some combination of diagnosing a device issue, navigating whatever promotion just changed overnight, and juggling five things at once without dropping any of them. It's taught me a lot about staying organized under pressure. I'm also working on a Master's in Computer Science, focused on machine learning, at Georgia Tech, and slowly rebuilding my coding muscle in the process.
                        <br/>
                                      <br/>

Outside of work, you'll find me at judo or boxing (I'm not particularly good at either, but I'm having fun), lifting weights, at a concert, or hanging out with my dog.
                        <br/>
                                      <br/>

I'm currently open to new opportunities where I can keep building and keep learning. If you're hiring, know someone who is, or just want to talk, I'd love to hear from it.
          </p>
        </div>
    </section>
  );
}
